export default __webpack_public_path__ + "static/media/appScreenBgMb2.f31adbb5.png";